import { createElement, styled, composedProps } from '@vebox/etui-system';

const H2Element = createElement('h2');
const H2 = styled(H2Element)(composedProps);

export { H2 };
